import DomTree from "./DomTree";

class TaggedText {
  constructor(text, domEls, tags) {
    this.text = text || "";
    this.tags = tags || [];

    const tagEls = this.tags.map((x) => ({ ...x, attr: "tag", data: x }));
    const allEls = (domEls || []).concat(tagEls);
    const els = allEls.map((x) => new DomTree(x));

    this.domTree = new DomTree({ start: 0, end: this.text.length })
      .setChildren(els)
      .expandText(this.text);
  }
}

export default TaggedText;
